import React from 'react';
import Base from './Base'

export class AuthFooter extends Base {
    constructor(props) {
        super(props);
        this.state ={
            data: props.Data
        }
   }

  render() {
      return <div className="nk-footer nk-auth-footer-full" style={{ backgroundColor: "#16498a" }}>
                  <div className="container wide-lg">
                      <div className="row g-3">
                          <div className="col-lg-6 order-lg-last">
                      <ul className="nav nav-sm justify-content-center justify-content-lg-end">
                          {!this.isBlank(this.state.data.link1Text) && < li className="nav-item">
                              <a className="nav-link text-white" target="_blank" href={this.state.data.link1Url}>{this.state.data.link1Text}</a>
                          </li>}
                          {!this.isBlank(this.state.data.link2Text) && <li className="nav-item">
                              <a className="nav-link text-white" target="_blank" href={this.state.data.link2Url}>{this.state.data.link2Text}</a>
                          </li>}
                          {!this.isBlank(this.state.data.link3Text) && <li className="nav-item">
                              <a className="nav-link text-white" target="_blank" href={this.state.data.link3Url}>{this.state.data.link3Text}</a>
                          </li>}
                              </ul>
                          </div>
                          <div className="col-lg-6">
                              <div className="nk-block-content text-center text-lg-start">
                          <p className="text-white">  تمامی حقوق این سایت متعلق به شرکت سپهر داده پرداز زینو میباشد.</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
  }
}
